// extracted by mini-css-extract-plugin
export default {"fs":"_49a3a7f4eb _824a921a19"};